import { NgModule } from '@angular/core';

import { HttpClientModule } from '@angular/common/http';
import { ColorsPipe } from '../core/colors/colors.pipe';
import { TranslatePipe } from '../core/translation/translate.pipe';
import { FileSizePipe } from '../shared/pipes/file-size.pipe';

@NgModule({
  declarations: [
    TranslatePipe,
    ColorsPipe,
    FileSizePipe
  ],
  imports: [
    HttpClientModule
  ],
  exports: [
    TranslatePipe,
    ColorsPipe,
    FileSizePipe
  ]
})
export class CoreModule {

}
